<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h3 style="color: black;">Parametres de l'analyse d'image</h3>
          </div>

          <div class="modal-body">
            <div v-if="!image">
            <div>Fond de carte</div>
            <div style="display: flex; gap: 30px; width: 100%;">
              <div v-for="(map, i) in maps" :key="i" style="width: 50%;">
                <l-map v-if="map==='esri'" ref="refMap" zoom="15" :center="centre" :options="mapOptions" style="width: 100%; height: 200px;">
                  <l-tile-layer :name="tileProvider.name" :visible="tileProvider.visible" :url="tileProvider.url"
                    layer-type="base" />
                </l-map>
                <img v-if="map==='google'" :src="staticMapUrl" alt="Carte Satellite de Google" />

                <v-radio-group v-model="param.map">
                  <v-radio :label="map" :value="map" class="radio">{{ map }}</v-radio>
                </v-radio-group>
              </div>
            </div>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <div>
                <div> Seuil de détection de la probabilité</div>
                <select class="createSelect" v-model="param.treshold">
                  <option v-for="(data, index) in seuil" :key="index" :value="data.value">{{ data.name }}
                  </option>
                </select>
              </div>
              <div>
                <div> dimension de l'image à analyser</div>
                <select class="createSelect" v-model="param.size">
                  <option v-for="(data, index) in taille" :key="index" :value="data.value">{{ data.name }}
                  </option>
                </select>
              </div>
            </div>
            <v-checkbox v-if="!image" v-model="param.tile" label="Faire l'analyse tuile par tuile" class="check" />
            <v-checkbox v-if="!image" v-model="param.perimeter" label="Faire l'analyse périmètre par périmètre" class="check" />
            <v-checkbox v-model="supp" label="Supprimer les blocs de panneaux actuelement sur la carte" class="check" />
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <v-btn style="float: right; right: 5px; bottom: 30px; " @click="pasAnalyse()">
                Continuer sans l'analyse d'image
              </v-btn>
              <v-btn style="float: right; right: 5px; bottom: 30px; margin-right: 10px;" @click="analyse()">
                Lancer l'analyse d'image
              </v-btn>
            </slot>
          </div>
        </div>
      </div>
      <PopUpTraitement v-if="openModal" @close="$emit('close')"/>
    </div>
  </transition>

</template>

<script>
import backend from '@/api/backend';
import PopUpTraitement from './PopUpTraitement.vue';


export default {
  name: "PopUpAnalyse",

  props: {
    centre: {
      required: true
    },
    install_id: {
      required: true
    },
    image: {
      require: true
    }
  },

  components: { PopUpTraitement },

  data() {
    return {
      openModal: false,
      param: {
        "size": 1024,
        "treshold": 0.5,
        "map": "google",
        "perimeter": true,
        "tile": false,

      },
      "supp": false,
      maps: ["google", "esri"],
      seuil: [{ "name": "bas", "value": 0.2 },
      { "name": "moyen", "value": 0.5 },
      { "name": "haut", "value": 0.8 }],
      taille: [{ "name": "petite", "value": 512 },
      { "name": "moyenne", "value": 1024 },
      { "name": "grande", "value": 2048 }],

      tileProvider:
      {
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
        visible: true,
        name: "satelliteESRI",
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
      },

      //pour que la map ne soit pas interactive
      mapOptions: {
        dragging: false,
        touchZoom: false,
        doubleClickZoom: false,
        scrollWheelZoom: false,
        keyboard: false,
        zoomControl: false,
        boxZoom: false,
        tap: false,
      },

      zoom: 15,
      size: '600x200',        // largeur x hauteur en pixels
      apiKey: ''    //Ajouter la cléd'API
    }
  },

  computed: {
    staticMapUrl() {
      return `https://maps.googleapis.com/maps/api/staticmap?center=${this.centre.lat},${this.centre.lng}&zoom=${this.zoom}&size=${this.size}&maptype=satellite&key=${this.apiKey}`;
    },
  },


  methods: {
    analyse() {
      //lance l'analyse
      backend.launch_analysis(this.install_id, this.param)

      //supprime les blocs precedent
      if(this.supp)
        backend.delete_blocs_install(this.install_id)


      this.openModal=true
    },

    pasAnalyse(){
      this.$emit('close')
    }
  }
}

</script>

<style scoped>
.modal-container {
  width: 50vw;
  height: 70vh;
  margin: 0px auto;
  padding: 2vh;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  border-radius: 0.25rem;
  position: relative;
  display: flex;
  flex-direction: column;
}

.modal-header {
  font-weight: bold;
  font-size: 1.4rem;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: left;
  /* align-items: center; */
  justify-content: center;
  max-height: 55vh;
  overflow-y: auto;
  margin-bottom: 5px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-footer {
  padding: 1vh 1vh;
  background-color: white;
  color: white;
  position: absolute;
  bottom: 0;
  right: 0;
}
img {
  max-width: 100%;
  height: 200px;
  display: block;
}

.check ::v-deep .v-messages {
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Texte en noir */
.check ::v-deep .v-label {
  color: black !important;
}

.radio ::v-deep .v-label {
  color: black !important;
}

.check {
  width: 100%;
  margin-top: 0;
}
</style>